// import {
//   UilUsersAlt,
//   UilFocusAdd,
//   UilCommentAltDownload,
//   UilChart,
//   UilTransaction,
//   UilBuilding,
//   UilChartPieAlt,
// } from "@iconscout/react-unicons";

// import { ReactComponent as Conversations } from "@/public/assets/app-images/messages.svg";
import config from "@/config";
import Conversations from "@/public/assets/app-images/messages.svg";
import { returnURL } from "@/services/generic.methods";

const CRMRoutes = [
  // {
  //   path: "/crm/analytics",
  //   name: "analytics",
  //   title: "Analytics",
  //   // icon: <UilChartPieAlt />,
  //   redirect: true,
  //   redirectPath: `${returnURL()}analytics`,
  //   haspopup: false,
  // },

  {
    path: "",
    name: "analytics",
    title: "Analytics",
    commonPath: "/crm/analytics/",
    // icon: <UilFocusAdd />,
    redirect: false,
    // redirectPath: `${returnURL()}portal/automation`,
    haspopup: true,
    childRoutes: [
      {
        path: "/crm/analytics/dashboard",
        name: "dashboard",
        title: "Dashboards",
        // icon: <UilUsersAlt />,
        redirect: false,
      },
      {
        path: "/crm/analytics/reports",
        name: "reports",
        title: "Reports",
        // icon: <UilUsersAlt />,
        redirect: false,
      },
    ],
  },
  // {
  //   path: "/crm/messaging",
  //   name: "messaging",
  //   title: "Messaging",
  //   // icon: <UilCommentAltDownload />,
  //   // iconRightSide: <UilTransaction size="17" />,
  //   // redirect: 'http://test.apexchat.com/dashboard.aspx',
  //   secondKey: "allowMessaging",
  //   redirect: true,
  //   redirectPath: `${returnURL()}portal/messaging`,
  //   haspopup: false,
  // },
  // {
  //   path: "/crm/companies",
  //   name: "company",
  //   title: "Companies",
  //   // icon: <UilBuilding />,
  //   redirect: true,
  //   redirectPath: "https://mytest.apexchat.com/portal/companies",
  // },
  // {
  //   path: "/crm/conversations",
  //   name: "conversation",
  //   title: "Conversations",
  //   // icon: Conversations,
  //   redirect: true,
  //   redirectPath: `${returnURL()}portal/conversations`,
  //   haspopup: false,
  // },
  {
    path: "",
    name: "lead",
    title: "Leads",
    commonPath: "/crm/leads",
    // icon: <UilUsersAlt />,
    redirect: false,
    haspopup: true,
    childRoutes: [
      {
        path: "/crm/leads",
        name: "lead",
        title: "Leads",
        // icon: <UilUsersAlt />,
        redirect: false,
      },
      {
        path: "/crm/leads/list",
        name: "list",
        title: "Lists",
        // icon: <UilUsersAlt />,
        redirect: false,
      },
    ],
  },
  // {
  //   path: "/crm/report",
  //   name: "report",
  //   title: "Reports",
  //   // icon: <UilChart />,
  //   redirect: true,
  //   redirectPath: `${returnURL()}portal/report`,
  //   haspopup: false,
  // },
  // {
  //   path: "/crm/onboarding",
  //   name: "onBoarding",
  //   title: "Onboarding",
  //   // icon: <UilFocusAdd />,
  //   redirect: true,
  //   redirectPath: `${returnURL()}portal/onboarding`,
  //   haspopup: false,
  // },
  {
    path: "",
    name: "automation",
    title: "Automation",
    commonPath: "/crm/automation/",
    // icon: <UilFocusAdd />,
    redirect: false,
    // redirectPath: `${returnURL()}portal/automation`,
    haspopup: true,
    childRoutes: [
      {
        path: "/crm/automation/automations",
        name: "automations",
        title: "Automations",
        // icon: <UilUsersAlt />,
        redirect: false,
      },
      {
        path: "/crm/automation/templates",
        name: "template",
        title: "Templates",
        // icon: <UilUsersAlt />,
        redirect: false,
      },
    ],
  },
  {
    path: "/crm/appointments",
    name: "appointments",
    title: "Appointments",
    // icon: <UilFocusAdd />,
    redirect: false,
    redirectPath: ``,
    haspopup: false,
  },
  {
    path: "/crm/sales/tasks",
    name: "sales",
    title: "Tasks",
    // commonPath: "/crm/sales/",
    // icon: <UilFocusAdd />,
    redirect: false,
    redirectPath: ``,
    haspopup: false,
    // childRoutes: [
    //   {
    //     path: "/crm/sales/tasks",
    //     name: "tasks",
    //     title: "Tasks",
    //     // icon: <UilUsersAlt />,
    //     redirect: false,
    //   },
    // ],
  },
];

export default CRMRoutes;
